import type { AllRouteEndpoints } from "../routeTypes";
import { appSettingsCustomEventUsage } from "@dashboardApi/apis/appSettingsCustomEventUsage/constants";
import { appSettingsCustomEventsData } from "@dashboardApi/apis/appSettingsCustomEventsData";

export const appsAppGroupIdCustomEventsSettingsCreateCacheKeys: AllRouteEndpoints[] = [
  appSettingsCustomEventsData,
  appSettingsCustomEventUsage,
];
